import { get } from 'lodash';
import { push, replace } from 'connected-react-router';
import PLAYER_TYPES from 'constants/player-types';
import PAGES from 'constants/pages';
import { pagesActions } from 'store/pages';
import { NAVIGATE_TO_PLAYER } from './action-types';
import { QueryParamsType } from './types';

interface INavigateToPlayerPage {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  episodeId?: number;
  useReplace?: boolean;
}

export const navigateToPlayer = ({
  item,
  episodeId,
  useReplace = false,
}: INavigateToPlayerPage) => (dispatch) => {
  try {
    const { id, type, asset_type, asset_id } = item;
    const itemType = asset_type || type;
    const itemID = asset_id || id;

    let url = '';
    dispatch({ type: NAVIGATE_TO_PLAYER });

    const routerAction = useReplace ? replace : push;

    if (itemType === 'series') {
      const firstEpisodeId = get(item.series_seasons, [0, 'episodes', 0, 'id']);
      url = `/player/${itemType}/${itemID}/${episodeId ? episodeId : firstEpisodeId}`;
    } else if (itemType === 'movie') {
      url = `/player/${itemType}/${itemID}`;
    } else if (itemType === 'channel') {
      url = `/player/${itemType}/${itemID}`;
    }
    if (url) dispatch(routerAction(url));
  } catch (error) {
    console.error(error);
  }
};

interface ILoadPlayerData {
  queryParams: QueryParamsType;
  playerType: keyof typeof PLAYER_TYPES;
}

export const loadPlayerData = ({ queryParams, playerType }: ILoadPlayerData) => (dispatch) => {
  if (([PLAYER_TYPES.MOVIE, PLAYER_TYPES.SERIES] as string[]).includes(playerType)) {
    const params = {
      type: playerType.toLowerCase(),
      id: queryParams.objectId,
    };
    // todo: check before fetch
    dispatch(pagesActions.loadData({ pageId: PAGES.DETAILS, params }));
  } else if (playerType === PLAYER_TYPES.CHANNEL) {
    // need to load all channels because in-player navigation
    dispatch(pagesActions.loadData({ pageId: PAGES.LIVE_TV, params: { all: true } }));
  }
};
